import { ApplicationsTableView } from "shared/app/ApplicationsTableView";
import { UnitDetails } from "./UnitDetails";
import { Unit } from "types/landlord/address";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { DiscountCodesTab } from "./DiscountCodesTab";
import { LeadsTableView } from "shared/app/LeadsTableView";

interface TabContentProps {
  tab: string;
  unit?: Unit;
}

export const TabContent = ({ tab, unit }: TabContentProps) => {
  const dictionary = useUnitsPropertiesDictionary();

  const renderTabContent = () => {
    switch (tab) {
      case "Applications":
        return (
          <div className="mt-4">
            <ApplicationsTableView unitId={Number(unit?.id)} />
          </div>
        );
      case `${dictionary.Units} details`:
        return <UnitDetails unit={unit} />;

      case "Leads":
        return <LeadsTableView unit_ids={unit?.id ? [String(unit.id)] : []} />;
      case "Discount codes":
        return <DiscountCodesTab />;
      default:
        return null;
    }
  };

  return <>{renderTabContent()}</>;
};
